<template>
  <div id="Zbcp">
    <div class="header">
      <el-form :inline="true" class="demo-form-inline forms">
        <el-form-item>
          <el-button type="primary" @click="add">添加</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table">
      <div class="content">
        <el-table :data="tableData" style="width: 100%" ref="table">
          <el-table-column prop="id" label="编号" key="id"></el-table-column>

          <el-table-column width="800" label="图片">
            <template slot-scope="scope">
              <!-- <img
                style="width: 345px; height: 190px"
                :src="scope.row.image"
                alt
              /> -->
              <el-image
                style="width: 345px; height: 190px"
                :src="scope.row.image"
                alt
                fit="cover"
              />
            </template>
          </el-table-column>
          <el-table-column width="100" key="todo" label="操作">
            <template slot-scope="scope">
              <span @click="bj(scope.$index, scope.row)" class="btns"
                >编辑</span
              >
              <span @click="sc(scope.$index, scope.row)" class="btns"
                >删除</span
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <el-dialog
      title="修改Banner"
      :visible.sync="editFormVisible"
      :close-on-click-modal="false"
      class="edit-form"
      :before-close="handleClose"
    >
      <el-form :model="editForm" label-width="120px" ref="editForm">
        <el-form-item label="Banner：" required>
          <span>建议690*320</span>
          <el-upload
            :class="imagesWF.length > 0 ? 'hide1' : ''"
            action=""
            list-type="picture-card"
            accept="image/*"
            :multiple="false"
            :limit="1"
            :auto-upload="false"
            :file-list="imagesWF"
            :on-change="handleWFOnchange"
            :on-remove="handleWFRemove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="handleCancel('editForm')">取消</el-button>
        <el-button type="primary" @click.native="handleUpdate('editForm')"
          >更新</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="添加Banner"
      :visible.sync="newData"
      :close-on-click-modal="false"
      class="edit-form"
      :before-close="newClose"
    >
      <el-form :model="newForm" label-width="120px" ref="newForm">
        <el-form-item label="Banner：" required>
          <span>建议690*320</span>
          <el-upload
            :class="imagesWF.length > 0 ? 'hide1' : ''"
            action=""
            list-type="picture-card"
            accept="image/*"
            :multiple="false"
            :limit="1"
            :auto-upload="false"
            :file-list="imagesWF"
            :on-change="handleWFOnchange"
            :on-remove="handleWFRemove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="newCancel('newForm')">取消</el-button>
        <el-button type="primary" @click.native="newUpdate('newForm')"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getBanner } from "../axios/api";
export default {
  name: "Banner",
  data() {
    return {
      imagesWF: [],
      tableData: [],
      total: 0, //默认数据总数
      pagesize: 10, //每页的数据条数
      currentPage: 1, //默认开始页面
      newData: false,
      newForm: {},
      editFormVisible: false,
      editForm: {},
    };
  },
  methods: {
    // 上传图片时的钩子
    handleWFOnchange(file, fileList) {
      var that = this;
      const formData = new FormData();
      if (file) {
        formData.append("file", file.raw);
      }
      // console.log(formData.get('file'))

      getBanner
        .upload(formData)
        .then(function (res) {
          // console.log(res);
          if (res.code !== 0) {
            that.$alert(res.message + "!", "提示", {
              confirmButtonText: "确定",
            });
          } else {
            // console.log(res.data)

            that.imagesWF.push(res.data);

            that.$message.success("上传成功!");
          }
        })
        .catch(function (res) {});
    },
    // 上传图片的删除
    handleWFRemove(file, fileList) {
      if (fileList) {
        this.imagesWF = fileList;
      }
    },
    // 添加
    add: function () {
      this.newData = true;
    },

    newClose(done) {
      this.newData = false;
      this.imagesWF = [];
      this.$refs["newForm"].clearValidate();
    },
    newCancel: function () {
      this.newData = false;
      this.imagesWF = [];
      this.$refs["newForm"].clearValidate();
    },
    newUpdate() {
      var that = this;
      that.$refs["newForm"].validate((valid) => {
        if (valid) {
          let newImages = [];
          that.imagesWF.map((img) => {
            newImages.push(img.url);
          });

          let data = {
            image: newImages.toString(),
          };

          if (data.image == "") {
            this.$message.warning("请上传品牌照片!");
            return;
          }
          // console.log(data)
          // return
          getBanner
            .addBanner(JSON.stringify(data))
            .then(function (res) {
              if (res.code !== 0) {
                that.$alert(res.message + "!", "提示", {
                  confirmButtonText: "确定",
                });
              } else {
                that.$message.success("添加成功!");
                that.newData = false;
                that.newForm = {};
                that.$refs["newForm"].resetFields();
                that.imagesWF = [];
                // that.currentPage = 1
                that.init();
              }
            })
            .catch(function (res) {
              that.$alert(res.message + "!", "提示", {
                confirmButtonText: "确定",
              });
            });
        }
      });
    },

    // 编辑
    bj: function (index, row) {
      var that = this;
      this.editFormVisible = true; //显示弹框

      this.editForm = row; // editForm是Dialog弹框的data

      let newData = [];
      let newImage = {};
      newImage.url = row.image;
      newData.push(newImage);

      // console.log(newData)
      this.imagesWF = newData;
    },
    handleClose(done) {
      this.editFormVisible = false;
      this.imgList = [];
    },
    handleCancel: function () {
      this.editFormVisible = false;
      this.imgList = [];
    },
    handleUpdate: function () {
      var that = this;
      let newImages = [];
      that.imagesWF.map((img) => {
        newImages.push(img.url);
      });

      let data = {
        image: newImages.toString(),
      };
      if (data.image == "") {
        this.$message.warning("请上传Banner!");
        return;
      }
      getBanner
        .editBanner(data, that.editForm.id)
        .then(function (res) {
          if (res.code !== 0) {
            that.$alert(res.message + "!", "提示", {
              confirmButtonText: "确定",
            });
          } else {
            that.$message.success("更新成功!");
            that.editFormVisible = false;
            that.$refs["editForm"].resetFields();
            that.imagesWF = [];
            // that.currentPage = 1
            that.init();
          }
        })
        .catch(function (res) {
          that.editFormVisible = false;
          that.$refs["editForm"].resetFields();
          // console.log(res)
          that.$alert(res.message + "!", "提示", {
            confirmButtonText: "确定",
          });
        });
    },
    // 删除
    sc: function (index, row) {
      var that = this;
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          getBanner
            .delBanner({
              id: row.id,
            })
            .then(function (res) {
              if (res.code !== 0) {
                that.$alert(res.message + "!", "提示", {
                  confirmButtonText: "确定",
                });
              } else {
                // that.currentPage = 1;
                that.init();
                that.$message({
                  type: "success",
                  message: "删除成功!",
                });
              }
            })
            .catch(function (error) {
              that.$message({
                type: "info",
                message: res.message,
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    init: function () {
      var that = this;
      //获取table列表
      getBanner.getBanner().then(function (res) {
        if (res.code !== 0) {
          that.$alert(res.message + "!", "提示", {
            confirmButtonText: "确定",
          });
        } else {
          // console.log(res)

          that.tableData = res.data;
        }
      });
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/page/Banner.vue